import styled from "styled-components";
import { resetButtonStyling } from "styles/commonStyles";
import fonts from "styles/fonts";

export const ClientDetailsContainer = styled.div`
  margin: 3em 0;
  max-width: 45em;
`;

export const ContentDiv = styled.div`
  font-size: ${fonts.smallMedium};
`;

export const RequestSecretButton = styled.button`
  ${resetButtonStyling};
  color: black;
`;

export const CreateQueueContainer = styled.div`
  padding-bottom: 2em;
  display: flex;
  justify-content: space-between;
  align-items: start;

  > p {
    font-size: ${fonts.xSmall};
  }
`;
